import React from 'react';

import { AuthContext } from '../../../context/AuthContext';
import { NavigationContext } from '../../../context/NavigationContext';

export const loadContextMethods = () => {
    const authContext = React.useContext(AuthContext);
    if (!authContext) {
        throw new Error('LoginScreen must be used within an AuthProvider');
    }
    const { login, loginWithTFA } = authContext;
    const navigationContext = React.useContext(NavigationContext);
    if (!navigationContext) {
        throw new Error('LoginScreen must be used within a NavigationProvider');
    }
    const { navigateTo } = navigationContext;

    return { login, loginWithTFA, navigateTo };
}